import { render, staticRenderFns } from "./GraficoPeso.vue?vue&type=template&id=23acfc2e&scoped=true"
import script from "./GraficoPeso.vue?vue&type=script&lang=js"
export * from "./GraficoPeso.vue?vue&type=script&lang=js"
import style0 from "./GraficoPeso.vue?vue&type=style&index=0&id=23acfc2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23acfc2e",
  null
  
)

export default component.exports